import baseConfiguratorReducer, {
  configurationHandler as baseConfigurationHandler,
  setSubReducers,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Reducer';
import {
  RECEIVE_CONFIGURATION,
  RECEIVE_SWITCHOPTIONSRESULT,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { sizeOptionClassification } from '../../Constants/sizeOptionClassification';
import { ActionTypes } from './types';
import { getFirstItemClassificationIdentifier, hasItemClassification } from './Selecctors';

function configurationHandler(state, action) {
  switch (action.type) {
    case RECEIVE_CONFIGURATION: {
      const nextState = baseConfigurationHandler(state, action);
      const itemIdentifier = nextState.configuration.item.identifier;
      const itemOptions = updateSelectedItemOption(nextState.itemOptions, itemIdentifier);
      return {
        ...nextState,
        itemOptions,
        options: [],
        sizeOptionClassification: getSizeOptionClassificationWithSelectedOption(itemOptions, itemIdentifier),
        selectedComponentGroup: null,
      };
    }
    case RECEIVE_SWITCHOPTIONSRESULT: {
      const nextState = baseConfigurationHandler(state, action);
      const { selectedComponentGroup } = nextState;
      return {
        ...nextState,
        selectedComponentGroup:
          (selectedComponentGroup &&
            nextState.configuration.information.components.find(
              ({ identifier }) => identifier === selectedComponentGroup.identifier
            )) ||
          null,
      };
    }
    default: {
      return baseConfigurationHandler(state, action);
    }
  }
}

setSubReducers({
  configurationHandler,
});

export default function configuratorReducer(state, action) {
  switch (action.type) {
    case ActionTypes.SET_ITEMS: {
      const itemIdentifier = state.configuration.item.identifier;
      const itemClassificationIdentifier = getFirstItemClassificationIdentifier(state.configuration.item);
      const sameClassificationOptions = filterSameItemClassification(
        action.payload,
        itemClassificationIdentifier
      );
      const itemOptions = updateSelectedItemOption(sameClassificationOptions, itemIdentifier);
      return {
        ...state,
        itemOptions,
        options: itemOptions,
        sizeOptionClassification: getSizeOptionClassificationWithSelectedOption(itemOptions, itemIdentifier),
      };
    }
    case ActionTypes.SET_SELECTED_COMPONENT_GROUP: {
      return {
        ...state,
        selectedComponentGroup: action.payload,
      };
    }
    default: {
      return baseConfiguratorReducer(state, action);
    }
  }
}

function filterSameItemClassification(items, itemClassificationIdentifier) {
  return items.filter((item) => hasItemClassification(item, itemClassificationIdentifier));
}

function updateSelectedItemOption(options, itemIdentifier) {
  return (options || []).map((option) => ({
    ...option,
    amount: option.identifier === itemIdentifier ? 1 : null,
  }));
}

function getSizeOptionClassificationWithSelectedOption(options, itemIdentifier) {
  return {
    ...sizeOptionClassification,
    selectedoptions: options.filter((option) => option.identifier === itemIdentifier),
  };
}
